<div class="downgrade-dialog">

  <!-- Header -->
  <div class="flex items-start sm:items-center justify-between !px-3 !py-2 sm:!py-0 mb-1 border-b border-slate-100">
    <h2 mat-dialog-title class="!m-0 !p-0 text-[18px] font-bold text-slate-800 leading-tight pr-4">Before you downgrade</h2>
    <button mat-icon-button class="text-slate-400 hover:text-slate-600 transition-colors shrink-0 -mt-1 sm:mt-0"
      (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">

    <!-- General downgrade warnings (retention, immediate restrictions) -->
    <!-- <div class="flex-col p-4 rounded-xl mb-5 bg-[#eff6ff] border border-solid border-[#bfdbfe] shadow-sm"
      *ngIf="hasInformationalContent">
      <div class="flex gap-3 items-start w-full">
        <mat-icon class="text-[#2563eb] shrink-0 mt-0.5">info</mat-icon>
        <div class="flex flex-col gap-1.5">
          <p class="text-[#2563eb] text-[14px] font-medium !mb-0 !mt-0 leading-snug tracking-[inherit]">
            Downgrading will immediately apply the selected plan restrictions. Some monitoring features may stop working
            until your workspace configuration is updated.
          </p>
          <div *ngIf="data.warningMessages.length" class="flex flex-col gap-1 mt-1">
            <p *ngFor="let message of data.warningMessages"
              class="text-[#475569] text-[13px] !mb-0 !mt-0 leading-relaxed" [innerHTML]="message">
            </p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Export / feature-loss reminders (non-blocking) -->
    <div class="flex-col mb-4 bg-white border border-solid border-slate-200 rounded-xl overflow-hidden"
      *ngIf="data.isValid && informationalSettingDetails.length">
      <!-- Accordion Header -->
      <div class="flex gap-4 p-4 cursor-pointer select-none group hover:bg-slate-50 transition-colors"
        (click)="toggleInformationalSection()">
        <div
          class="flex items-center justify-center w-11 h-11 rounded-xl shrink-0 bg-amber-50 text-amber-600 border border-amber-100">
          <mat-icon class="!text-[22px] !w-[22px] !h-[22px]">warning_amber</mat-icon>
        </div>
        <div class="flex-col flex-1 justify-center">
          <div class="flex items-start sm:items-center justify-between w-full">
            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-1.5 sm:gap-3">
              <h3
                class="!text-amber-700 !mb-0 !mt-0 text-[16px] font-semibold group-hover:text-amber-800 transition-colors leading-tight">
                Export these if you still need them</h3>
              <span
                class="bg-amber-100/80 !px-3 !py-0.5 text-amber-800 !rounded-full text-[11px] !font-bold uppercase tracking-wider inline-block">Review
                Recommended</span>
            </div>
            <mat-icon class="text-slate-400 transition-transform duration-300"
              [class.rotate-180]="isInformationalExpanded">expand_more</mat-icon>
          </div>
          <p class="text-[13.5px] !mb-0 !mt-1 text-slate-500 leading-snug">
            These do not block downgrading — export or save work if you need it.
          </p>
        </div>
      </div>

      <!-- Accordion Body -->
      <div class="flex flex-col gap-2 p-4 bg-slate-50 border-t border-slate-200/60" *ngIf="isInformationalExpanded">
        <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0"
          *ngFor="let setting of informationalSettingDetails">
          <div class="flex-1 pr-0 sm:pr-6 w-full">
            <p class="text-[15px] font-medium text-black capitalize !mb-0.5 !mt-0">{{ setting.label
              }}</p>
            <p class="text-[13px] text-slate-500 !mb-0 !mt-0 leading-relaxed">{{ setting.fixHint }}</p>
          </div>
          <div class="shrink-0 w-full sm:w-auto" *ngIf="setting.route">
            <button mat-stroked-button color="primary" type="button"
              class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
              (click)="navigateToRoute(setting.route)">
              <span class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] block">{{ setting.where
                }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Top warning -->
    <div class="flex items-start gap-3 mb-5 mt-2 bg-transparent text-slate-800" *ngIf="!data.isValid">
      <mat-icon class="!text-[20px] !w-[20px] !h-[20px] shrink-0 mt-[1px] text-red-500">warning</mat-icon>
      <p class="text-[13.5px] !mb-0 !mt-0 leading-relaxed font-medium">
        Your workspace uses features not included in the <span class="text-red-600 font-bold">{{ data.targetPlanName
          }}</span> plan.
        Resolve the items below before downgrading.
      </p>
    </div>


    <!-- Issues -->
    <div class="issues-stack" *ngIf="!data.isValid && data.issues.length">
      <div class="flex-col mb-4 bg-white border border-solid border-slate-200 rounded-xl overflow-hidden"
        *ngFor="let issue of data.issues; let i = index">

        <!-- Collapsible Header -->
        <div class="flex gap-4 p-4 select-none cursor-pointer transition-colors hover:bg-slate-50"
          (click)="toggleSection(i)">
          <div
            class="flex items-center justify-center w-11 h-11 rounded-xl shrink-0 bg-red-50 text-red-500 border border-red-100">
            <mat-icon class="!text-[22px] !w-[22px] !h-[22px]">{{ issue.icon }}</mat-icon>
          </div>
          <div class="flex-col flex-1 justify-center">
            <div class="flex items-start sm:items-center justify-between w-full">
              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-1.5 sm:gap-3">
                <h3 class="!text-slate-800 !mb-0 !mt-0 text-[16px] font-semibold leading-tight">{{ issue.title }}</h3>

              </div>
            </div>
            <p class="text-[13.5px] !mb-0 !mt-1 text-slate-500 leading-snug pr-4">
              {{ issue.description }}
            </p>
          </div>
          <div class="flex items-center justify-center shrink-0 ml-auto pl-2 text-slate-400">
            <mat-icon class="transition-transform duration-200"
              [class.rotate-180]="isSectionExpanded(i)">expand_more</mat-icon>
          </div>
        </div>

        <!-- Body -->
        <div class="flex flex-col gap-4 p-4 bg-slate-50 border-t border-slate-200/60" *ngIf="isSectionExpanded(i)">

          <!-- Affected employees (Always visible) -->
          <div class="flex flex-col gap-2" *ngIf="issue.affectedEmployees?.length">

            <div
              class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-2 sm:gap-0 !mb-2 !mt-0">
              <p class="text-[13.5px] font-medium text-slate-600 !m-0">Employees to Update ({{
                issue.affectedEmployees.length }})</p>
            </div>

            <div class="grid gap-3 overflow-y-auto max-h-[180px]"
              style="grid-template-columns: repeat(auto-fill, minmax(180px, 1fr))">
              <div
                class="flex items-center gap-2.5 px-3 py-2.5 rounded-lg border border-solid border-[#e5e7eb] bg-[#f6f7f9] transition-all hover:border-gray-300 cursor-pointer"
                *ngFor="let emp of issue.affectedEmployees" (click)="onEmployeeChipClick(emp, issue)">
                <div
                  class="flex-shrink-0 flex items-center justify-center rounded-full overflow-hidden w-[32px] h-[32px]">
                  <ngx-avatars name="{{ emp.name }}" size="32" initialsSize="2"></ngx-avatars>
                </div>
                <p class="!text-[13.5px] font-medium text-slate-700 truncate m-0">{{ emp.name }}</p>
                <div class="ml-auto flex items-center shrink-0">
                  <mat-icon *ngIf="emp.details?.length"
                    class="text-slate-400 hover:text-slate-600 transition-colors !text-[18px] !w-[18px] !h-[18px]"
                    [matTooltip]="getEmployeeChipTooltip(emp)" matTooltipPosition="above"
                    (click)="$event.stopPropagation()">
                    info_outline
                  </mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- Manager Roles: Bulk update to employee -->
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0"
            *ngIf="isManagerRolesIssue(issue) && issue.affectedEmployees?.length">
            <div class="flex-1 pr-0 sm:pr-6 w-full">
              <div class="flex items-center gap-2 !mb-0.5 !mt-0 flex-wrap">
                <mat-icon class="text-slate-400 !w-[18px] !h-[18px] !text-[18px]">group</mat-icon>
                <p class="text-[15px] font-medium text-slate-800 !m-0">Update Roles</p>
                <span
                  class="bg-indigo-50 text-indigo-700 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ml-0 sm:ml-2 mt-1 sm:mt-0">Required</span>
              </div>
            </div>
            <div class="shrink-0 w-full sm:w-auto mt-2 sm:mt-0">
              <button mat-stroked-button color="primary" type="button"
                class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
                (click)="onSwitchManagersToEmployees(issue)">
                <span
                  class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] flex items-center justify-center gap-1.5">
                  <mat-icon class="!text-[16px] !w-[16px] !h-[16px]">sync_alt</mat-icon>
                  Update All
                </span>
              </button>
            </div>
          </div>

          <!-- Personalized Settings: Update settings via dialog -->
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0"
            *ngIf="isPersonalizedSettingsIssue(issue) && issue.affectedEmployees?.length">
            <div class="flex-1 pr-0 sm:pr-6 w-full">
              <div class="flex items-center gap-2 !mb-0.5 !mt-0 flex-wrap">
                <mat-icon class="text-slate-400 !w-[18px] !h-[18px] !text-[18px]">settings_suggest</mat-icon>
                <p class="text-[15px] font-medium text-slate-800 !m-0">Update Personalized Settings</p>
                <span
                  class="bg-indigo-50 text-indigo-700 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ml-0 sm:ml-2 mt-1 sm:mt-0">Required</span>
              </div>
              <p class="text-[13px] text-slate-500 !mb-0 !mt-1 leading-relaxed ml-0 sm:ml-[26px]">
                Adjust employee tracking intervals and disable restricted features to match your downgraded plan.
              </p>
            </div>
            <div class="shrink-0 w-full sm:w-auto mt-2 sm:mt-0">
              <button mat-stroked-button color="primary" type="button"
                class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
                (click)="onUpdatePersonalizedSettings(issue)">
                <span
                  class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] flex items-center justify-center gap-1.5">
                  <mat-icon class="!text-[16px] !w-[16px] !h-[16px]">edit</mat-icon>
                  Update Settings
                </span>
              </button>
            </div>
          </div>

          <!-- Hidden Mode: password reset + reinstall -->
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0"
            *ngIf="isHiddenModeIssue(issue) && issue.affectedEmployees?.length">
            <div class="flex-1 pr-0 sm:pr-6 w-full">
              <div class="flex items-center gap-2 !mb-0.5 !mt-0 flex-wrap">
                <mat-icon class="text-slate-400 !w-[18px] !h-[18px] !text-[18px]">visibility_off</mat-icon>
                <p class="text-[15px] font-medium text-slate-800 !m-0">Switch to Employee Controlled</p>
                <span
                  class="bg-amber-100 text-amber-800 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ml-0 sm:ml-2 mt-1 sm:mt-0">Password
                  reset required</span>
              </div>
              <p class="text-[13px] text-slate-500 !mb-0 !mt-1 leading-relaxed ml-0 sm:ml-[26px]">
                The employee will be signed out. After that, reinstall the <b>Employee Controlled</b> app.
              </p>
            </div>
            <div class="shrink-0 w-full sm:w-auto mt-2 sm:mt-0">
              <button mat-stroked-button color="primary" type="button"
                class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
                [disabled]="!hasMigratableHiddenEmployees(issue)" (click)="onSwitchHiddenToEmployeeControlled(issue)">
                <span
                  class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] flex items-center justify-center gap-1.5">
                  <mat-icon class="!text-[16px] !w-[16px] !h-[16px]">lock_reset</mat-icon>
                  Reset & Switch
                </span>
              </button>
            </div>
          </div>

          <!-- Admin Controlled: settings toggle only -->
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0"
            *ngIf="isAdminControlIssue(issue) && (issue.affectedEmployees?.length || issue.isGlobalAdminControl)">
            <div class="flex-1 pr-0 sm:pr-6 w-full">
              <div class="flex items-center gap-2 !mb-0.5 !mt-0 flex-wrap">
                <mat-icon class="text-slate-400 !w-[18px] !h-[18px] !text-[18px]">admin_panel_settings</mat-icon>
                <p class="text-[15px] font-medium text-slate-800 !m-0">
                  <ng-container *ngIf="issue.isGlobalAdminControl">Update Global Setting</ng-container>
                  <ng-container *ngIf="!issue.isGlobalAdminControl">Switch to Employee Controlled</ng-container>
                </p>
                <span
                  class="bg-indigo-50 text-indigo-700 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ml-0 sm:ml-2 mt-1 sm:mt-0">
                  <ng-container *ngIf="issue.isGlobalAdminControl">Required</ng-container>
                  <ng-container *ngIf="!issue.isGlobalAdminControl">Settings only</ng-container>
                </span>
              </div>

            </div>
            <div class="shrink-0 w-full sm:w-auto mt-2 sm:mt-0">
              <!-- Global update button -->
              <button *ngIf="issue.isGlobalAdminControl" mat-stroked-button color="primary" type="button"
                class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
                (click)="onUpdateGlobalAdminControl()">
                <span
                  class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] flex items-center justify-center gap-1.5">
                  <mat-icon class="!text-[16px] !w-[16px] !h-[16px]">edit</mat-icon>
                  Update Settings
                </span>
              </button>

              <!-- Employee-specific update button -->
              <button *ngIf="!issue.isGlobalAdminControl" mat-stroked-button color="primary" type="button"
                class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
                [disabled]="!hasMigratableAdminControlEmployees(issue)"
                (click)="onSwitchAdminControlToEmployeeControlled(issue)">
                <span
                  class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] flex items-center justify-center gap-1.5">
                  <mat-icon class="!text-[16px] !w-[16px] !h-[16px]">toggle_off</mat-icon>
                  Turn off Admin toggles
                </span>
              </button>
            </div>
          </div>


          <!-- Teams over limit -->
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0"
            *ngIf="isTeamsIssue(issue)">
            <div class="flex-1 pr-0 sm:pr-6 w-full">
              <div class="flex items-center gap-2 !mb-0.5 !mt-0">
                <mat-icon class="text-slate-400 !w-[18px] !h-[18px] !text-[18px]">groups</mat-icon>
                <p class="text-[15px] font-medium text-slate-800 !m-0">Reduce team count</p>
              </div>
              <p class="text-[13px] text-slate-500 !mb-0 !mt-1 leading-relaxed ml-0 sm:ml-[26px]">
                Remove or merge teams until you are within the {{ data.targetPlanName }} plan limit.
              </p>
            </div>
            <div class="shrink-0 w-full sm:w-auto">
              <button mat-stroked-button color="primary" type="button"
                class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
                (click)="openTeamReductionDialog()">
                <span class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] block">Open Teams</span>
              </button>
            </div>
          </div>

          <!-- Shifts over limit -->
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0"
            *ngIf="isShiftsIssue(issue)">
            <div class="flex-1 pr-0 sm:pr-6 w-full">
              <div class="flex items-center gap-2 !mb-0.5 !mt-0">
                <mat-icon class="text-slate-400 !w-[18px] !h-[18px] !text-[18px]">schedule</mat-icon>
                <p class="text-[15px] font-medium text-slate-800 !m-0">Delete extra shifts </p>
              </div>
            </div>
            <div class="shrink-0 w-full sm:w-auto">
              <button mat-stroked-button color="primary" type="button"
                class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
                (click)="openShiftReductionDialog()">
                <span class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] block">Delete
                  Shifts</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Workspace settings (Must resolve before downgrade) -->
    <div class="flex-col mb-4 bg-white border border-solid border-slate-200 rounded-xl overflow-hidden"
      *ngIf="!data.isValid && globalSettingDetails.length">
      <!-- Collapsible Header -->
      <div class="flex gap-4 p-4 select-none cursor-pointer transition-colors hover:bg-slate-50"
        (click)="toggleGlobalSettingsSection()">
        <div
          class="flex items-center justify-center w-11 h-11 rounded-xl shrink-0 bg-red-50 text-red-500 border border-red-100">
          <mat-icon class="!text-[22px] !w-[22px] !h-[22px]">settings</mat-icon>
        </div>
        <div class="flex-col flex-1 justify-center">
          <div class="flex items-start sm:items-center justify-between w-full">
            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-1.5 sm:gap-3">
              <h3 class="!text-slate-800 !mb-0 !mt-0 text-[16px] font-semibold leading-tight">Workspace Settings</h3>
              <span
                class="bg-red-100/80 !px-3 !py-0.5 text-red-700 !rounded-full text-[11px] !font-bold uppercase tracking-wider inline-block whitespace-nowrap">Change
                required</span>
            </div>
          </div>
          <p class="text-[13.5px] !mb-0 !mt-1 text-slate-500 leading-snug pr-4">
            Some workspace settings aren't supported on the Basic plan. Review and update the settings below to
            continue.
          </p>
        </div>
        <div class="flex items-center justify-center shrink-0 ml-auto pl-2 text-slate-400">
          <mat-icon class="transition-transform duration-200"
            [class.rotate-180]="isGlobalSettingsExpanded">expand_more</mat-icon>
        </div>
      </div>

      <!-- Body -->
      <div class="flex flex-col gap-1 p-4 border-t border-slate-200/60 bg-slate-50" *ngIf="isGlobalSettingsExpanded">
        <div class="flex flex-col">
          <div
            class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0 py-1 px-3 bg-transparent"
            *ngFor="let setting of globalSettingDetails">
            <div class="flex-1 pr-0 sm:pr-6 w-full">
              <div class="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 !mb-0.5 !mt-0">
                <p class="text-[15px] font-medium text-black capitalize !m-0 leading-tight">{{ setting.label }}</p>
                <span class="text-[11.5px] font-normal text-slate-500 inline-block"
                  *ngIf="setting.affectedCount !== undefined">
                  - {{ setting.affectedCount }} Employees to Update
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-end mt-1">
          <button mat-stroked-button color="primary" type="button"
            class="w-full sm:w-auto h-auto min-h-[36px] py-1.5 sm:py-0 !border-indigo-200 !text-indigo-700 !font-medium hover:!bg-indigo-50 transition-colors"
            (click)="onReviewSettings()">
            <span
              class="whitespace-normal sm:whitespace-nowrap leading-tight text-[13px] flex items-center justify-center gap-1.5">
              <mat-icon class="!text-[16px] !w-[16px] !h-[16px]">edit</mat-icon>
              Update Settings
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- Success -->
    <div class="flex flex-col gap-4 mb-5" *ngIf="data.isValid">
      <div class="flex flex-col p-5 bg-slate-50 border border-slate-200/60 rounded-xl">
        <p class="text-[14.5px] text-slate-600 !mb-0 !mt-0 border-b border-slate-200/80 pb-4">
          We've checked your workspace against the <b>{{ data.targetPlanName }}</b> plan.
          Everything looks good — you're ready to downgrade.
        </p>
        <div class="flex flex-col gap-3">
          <div class="flex items-center gap-3 text-slate-700" *ngFor="let item of successItems">
            <mat-icon class="text-[#10b981] shrink-0">check_circle</mat-icon>
            <span class="text-[14.5px] font-medium">{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-3 p-4 bg-[#ecfdf5] border border-[#a7f3d0] rounded-xl shadow-sm text-[#065f46]">
        <mat-icon class="text-[#10b981] shrink-0">check_circle</mat-icon>
        <p class="text-[14.5px] font-medium !m-0">Your workspace is ready to move to the <b>{{ data.targetPlanName
            }}</b> plan.</p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="flex flex-col sm:flex-row w-full items-center justify-between gap-3 pt-4 pb-2 border-t border-slate-100 mt-2 !mb-0 px-4">
    <!-- Left side: Need Help? link -->
    <div class="flex-shrink-0 mr-auto w-full sm:w-auto text-center sm:text-left mt-2 sm:mt-0 order-2 sm:order-1">
      <button mat-button color="primary" class="!font-medium" (click)="openSupportRequest()">
        <mat-icon class="!mr-1">help_outline</mat-icon> Need Help?
      </button>
    </div>

    <!-- Right side: Actions -->
    <div class="flex flex-col-reverse sm:flex-row gap-3 w-full sm:w-auto order-1 sm:order-2">
      <button mat-stroked-button type="button" class="action-secondary w-full sm:w-auto min-h-[40px] !m-0"
        (click)="onCancel()">
        {{ data.isValid ? 'Keep current plan' : 'Close' }}
      </button>
      <button mat-raised-button color="primary" type="button" class="action-primary w-full sm:w-auto min-h-[40px] !m-0"
        [disabled]="!data.isValid" (click)="onProceedDowngrade()">
        Downgrade to {{ data.targetPlanName }}
      </button>
    </div>
  </mat-dialog-actions>

</div>